import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';

import * as AssemblyModels from 'assembly/AssemblyModels';
import SingleFragmentWizard, {type SingleFragmentWizardOptions} from 'assembly/SingleFragmentWizard';
import {Sequence} from 'components/Sequence';
import * as AssemblyConstants from 'constants/AssemblyConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import FileState from 'filestate/FileState';
import FileStates, {SequenceFileState} from 'FileStates';

const fileStates = FileStates.get();
const {ASSEMBLY_TYPE} = AssemblyConstants;
const {assemblies} = AssemblyModels;

class WizardContainer extends Backbone.View<Backbone.Model> {
  sequence!: Sequence | null;
  view: SingleFragmentWizard | null = null;
  WIZARD_TYPES!: Record<AssemblyConstants.ASSEMBLY_TYPE, typeof SingleFragmentWizard>;

  static initClass(): void {
    this.prototype.el = '#assembly-wizard-container';

    this.prototype.WIZARD_TYPES = _.object([
      [ASSEMBLY_TYPE.DIGEST, SingleFragmentWizard],
      [ASSEMBLY_TYPE.GIBSON, SingleFragmentWizard],
      [ASSEMBLY_TYPE.GOLDEN_GATE, SingleFragmentWizard],
    ]);
  }

  override initialize(): void {
    this.view = null;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(assemblies, 'change:active change:slots add remove', this.updateAssembly);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(fileStates, 'change:active add remove reset', this.updateAssembly);
  }

  hideWizard(): void {
    $('#editor').removeClass('has-assemblyWizard').removeClass('has-assemblyWizard-info');
    $(window).trigger('buffersResize');
    this.$el.addClass('hidden');
  }

  updateAssembly(): void {
    if (this.view != null) {
      this.view.remove();
      this.view = null;
    }

    const assembly = assemblies.findWhere({active: true});
    const isSequenceFileActive =
      fileStates.find(
        (fileState) => fileState.active() && fileState.fileType() === ModelTypeConstants.SEQUENCE
      ) != null;
    if (assembly == null || !isSequenceFileActive) {
      this.hideWizard();
      return;
    }
    const WizardType = this.WIZARD_TYPES[assembly.method()!];
    this.view = new WizardType({
      model: assembly,
      sequence: this.sequence,
    } as SingleFragmentWizardOptions);
    this.$el.append(this.view.render().el);
    this.$el.removeClass('hidden');

    // Trigger 'opened' when an assembly is rendered to allow help tour to start
    assembly.trigger('opened');
  }

  update(fileState: FileState | null): void {
    if (
      fileState != null &&
      fileState.fileType() === ModelTypeConstants.SEQUENCE &&
      (fileState as SequenceFileState).model().type() !== 'oligo'
    ) {
      this.sequence = (fileState as SequenceFileState).model();
    } else {
      this.sequence = null;
    }
    if (this.view != null) {
      this.view.updateSequence(this.sequence);
    }
  }
}
WizardContainer.initClass();

export default WizardContainer;
